import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}'
*/
const GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.url(args, options),
    method: 'get',
})

GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.definition = {
    methods: ["get","head"],
    url: '/api/analytics-dashboard/{analytics_dashboard}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}'
*/
GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.url = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { analytics_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { analytics_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            analytics_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        analytics_dashboard: typeof args.analytics_dashboard === 'object'
        ? args.analytics_dashboard.id
        : args.analytics_dashboard,
    }

    return GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.definition.url
            .replace('{analytics_dashboard}', parsedArgs.analytics_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}'
*/
GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.get = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}'
*/
GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.head = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}/analytics-data'
*/
const GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110 = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.url(args, options),
    method: 'post',
})

GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.definition = {
    methods: ["post"],
    url: '/api/analytics-dashboard/{analytics_dashboard}/analytics-data',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}/analytics-data'
*/
GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.url = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { analytics_dashboard: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { analytics_dashboard: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            analytics_dashboard: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        analytics_dashboard: typeof args.analytics_dashboard === 'object'
        ? args.analytics_dashboard.id
        : args.analytics_dashboard,
    }

    return GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.definition.url
            .replace('{analytics_dashboard}', parsedArgs.analytics_dashboard.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::__invoke
* @see app/Http/Controllers/AnalyticsDashboard/GetAnalyticsDataByDashboardIdController.php
* @route '/api/analytics-dashboard/{analytics_dashboard}/analytics-data'
*/
GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.post = (args: { analytics_dashboard: string | number | { id: string | number } } | [analytics_dashboard: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110.url(args, options),
    method: 'post',
})

/**
* Multiple routes resolve to \App\Http\Controllers\AnalyticsDashboard\GetAnalyticsDataByDashboardIdController::GetAnalyticsDataByDashboardIdController, so this export is a
* dictionary keyed by URI rather than a callable, with the verbs prefixed where two routes share a URI.
* Call a specific route with `GetAnalyticsDataByDashboardIdController['<key>'](...)`, or import the route by name from your
* generated `routes/` directory.
*/
const GetAnalyticsDataByDashboardIdController = {
    '/api/analytics-dashboard/{analytics_dashboard}': GetAnalyticsDataByDashboardIdController28329693ad007de328fc132f0a0ced4b,
    '/api/analytics-dashboard/{analytics_dashboard}/analytics-data': GetAnalyticsDataByDashboardIdController5c120c85085df3655870bb850250c110,
}

export default GetAnalyticsDataByDashboardIdController